import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Search, MapPin, GraduationCap, Calendar, ExternalLink, ChevronLeft, BookOpen } from 'lucide-react';
import { getUniversidadesFromRTDB } from '../services/universidadesService';
import '../styles/UniversidadesConvocatorias.css';

const CONVOCATORIAS_POR_SIGLAS = {
  'UNINAV': { convocatoria: 'Enero (2da quincena)', registro: 'Enero – Marzo', examen: 'Abril – Mayo', resultados: 'Julio', modalidad: 'Presencial / Sedes Regionales SEMAR', notas: 'Aplica examen EXANI-II (Fase Preliminar) con módulos específicos por carrera, seguido de pruebas médica, física y psicológica en Fase Definitiva.' },
  'UNAM': { convocatoria: 'Enero – Febrero', registro: 'Febrero – Marzo', examen: 'Mayo – Junio', resultados: 'Junio – Julio', modalidad: 'Presencial / En Línea', notas: 'Concurso de Selección 2027. Aplica EXANI-II de 168 reactivos con módulos específicos por carrera.' },
  'IPN': { convocatoria: 'Enero – Febrero', registro: 'Febrero – Marzo', examen: 'Mayo', resultados: 'Junio', modalidad: 'Presencial', notas: 'Concurso de Ingreso IPN. Aplica EXANI-II oficial Ceneval.' },
  'UAM': { convocatoria: 'Enero – Febrero', registro: 'Febrero – Marzo', examen: 'Mayo – Junio', resultados: 'Junio – Julio', modalidad: 'Presencial', notas: 'Concurso de Ingreso UAM. Aplica EXANI-II.' },
  'UPN': { convocatoria: 'Febrero', registro: 'Febrero – Marzo', examen: 'Mayo', resultados: 'Junio', modalidad: 'Presencial / En Línea', notas: 'Proceso de admisión UPN con EXANI-II.' },
  'COLMEX': { convocatoria: 'Enero – Febrero', registro: 'Febrero – Marzo', examen: 'Mayo', resultados: 'Junio', modalidad: 'Presencial', notas: 'Proceso de admisión COLMEX con EXANI-II.' },
  'CIDE': { convocatoria: 'Enero – Febrero', registro: 'Febrero – Marzo', examen: 'Mayo', resultados: 'Junio', modalidad: 'Presencial', notas: 'Proceso de admisión CIDE con EXANI-II.' },
  'UnADM': { convocatoria: 'Continua', registro: 'Continua', examen: 'Por programar', resultados: 'Por programar', modalidad: 'En Línea', notas: 'Admisión por inscripción continua. Consulta fechas específicas en portal oficial.' },
  'UADY': { convocatoria: 'Febrero', registro: 'Febrero – Marzo', examen: 'Mayo – Junio', resultados: 'Junio', modalidad: 'Presencial', notas: 'Proceso de Ingreso Licenciatura 2027. Alta demanda en Premedicina.' },
  'UV': { convocatoria: 'Febrero', registro: 'Febrero – Marzo', examen: 'Mayo (fines de semana)', resultados: 'Junio', modalidad: 'Presencial / Examen Desde Casa', notas: 'Convocatoria General 2027. Aplica EXANI-II de 168 reactivos.' },
  'UJAT': { convocatoria: 'Febrero', registro: 'Febrero – Marzo', examen: 'Mayo – Junio', resultados: 'Junio', modalidad: 'Presencial', notas: 'Proceso de admisión UJAT con EXANI-II.' },
  'UAA': { convocatoria: 'Marzo', registro: 'Marzo', examen: 'Mayo', resultados: 'Junio', modalidad: 'Presencial', notas: 'Admisión Pregrado 2027. La UAA pondera el EXANI-II junto con el promedio.' },
  'UABCS': { convocatoria: 'Marzo', registro: 'Marzo – Abril', examen: 'Mayo – Junio', resultados: 'Junio', modalidad: 'Presencial', notas: 'Proceso de admisión UABCS con EXANI-II.' },
  'UACAM': { convocatoria: 'Febrero', registro: 'Febrero – Marzo', examen: 'Mayo', resultados: 'Junio', modalidad: 'Presencial', notas: 'Proceso de admisión UACAM con EXANI-II.' },
  'UNACAR': { convocatoria: 'Febrero', registro: 'Febrero – Marzo', examen: 'Mayo', resultados: 'Junio', modalidad: 'Presencial', notas: 'Proceso de admisión UNACAR con EXANI-II.' },
  'UNACH': { convocatoria: 'Febrero', registro: 'Febrero – Marzo', examen: 'Mayo', resultados: 'Junio', modalidad: 'Presencial', notas: 'Proceso de admisión UNACH con EXANI-II.' },
  'UACH': { convocatoria: 'Marzo', registro: 'Marzo – Abril', examen: 'Junio', resultados: 'Julio', modalidad: 'Presencial', notas: 'Proceso de admisión UACH con EXANI-II.' },
  'UAEH': { convocatoria: 'Febrero', registro: 'Febrero – Abril', examen: 'Mayo – Junio', resultados: 'Junio', modalidad: 'Presencial', notas: 'Convocatoria UAEH. Aplicación estricta de EXANI-II en Ciencias de la Salud.' },
  'UAEMEX': { convocatoria: 'Ago-Sep (2da vuelta)', registro: 'Septiembre', examen: 'Octubre – Noviembre', resultados: 'Noviembre', modalidad: 'Presencial en sedes UAEMéx', notas: 'Segunda Convocatoria para cupo remanente.' },
  'UAGRO': { convocatoria: 'Marzo', registro: 'Marzo – Abril', examen: 'Junio', resultados: 'Julio', modalidad: 'Presencial', notas: 'Proceso de admisión UAGRO con EXANI-II.' },
  'UAEM': { convocatoria: 'Febrero', registro: 'Febrero – Marzo', examen: 'Mayo', resultados: 'Junio', modalidad: 'Presencial', notas: 'Proceso de admisión UAEM con EXANI-II.' },
  'UAN': { convocatoria: 'Marzo', registro: 'Marzo – Abril', examen: 'Mayo', resultados: 'Junio', modalidad: 'Presencial', notas: 'Proceso de admisión UAN con EXANI-II.' },
  'UANL': { convocatoria: 'Marzo (1ra vuelta)', registro: 'Marzo – Mayo', examen: 'Junio (primer sábado)', resultados: 'Junio (finales)', modalidad: 'Presencial / En Línea', notas: 'Concurso de Ingreso 2027. Examen Ceneval oficial obligatorio.' },
  'UQROO': { convocatoria: 'Febrero', registro: 'Febrero – Marzo', examen: 'Mayo', resultados: 'Junio', modalidad: 'Presencial', notas: 'Proceso de admisión UQROO con EXANI-II.' },
  'UASLP': { convocatoria: 'Enero', registro: 'Enero – Mayo', examen: 'Julio (primeros días)', resultados: 'Julio', modalidad: 'Presencial en campus UASLP', notas: 'Admisión Licenciatura 2027. Combina examen psicométrico y EXANI-II.' },
  'UAS': { convocatoria: 'Febrero', registro: 'Febrero – Marzo', examen: 'Mayo', resultados: 'Junio', modalidad: 'Presencial', notas: 'Proceso de admisión UAS con EXANI-II.' },
  'UAT': { convocatoria: 'Marzo', registro: 'Marzo – Abril', examen: 'Junio', resultados: 'Julio', modalidad: 'Presencial', notas: 'Proceso de admisión UAT con EXANI-II.' },
  'UATX': { convocatoria: 'Febrero', registro: 'Febrero – Marzo', examen: 'Mayo', resultados: 'Junio', modalidad: 'Presencial', notas: 'Proceso de admisión UATX con EXANI-II.' },
  'UAZ': { convocatoria: 'Marzo', registro: 'Marzo – Abril', examen: 'Junio', resultados: 'Julio', modalidad: 'Presencial', notas: 'Proceso de admisión UAZ con EXANI-II.' },
  'UCOL': { convocatoria: 'Marzo', registro: 'Marzo – Abril', examen: 'Mayo', resultados: 'Junio', modalidad: 'Presencial', notas: 'Proceso de admisión UCOL con EXANI-II.' },
  'UP': { convocatoria: 'Enero', registro: 'Enero – Febrero', examen: 'Marzo', resultados: 'Abril', modalidad: 'Presencial / En Línea', notas: 'Proceso de admisión Universidad Panamericana.' }
};

export default function UniversidadesConvocatoriasPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [universidades, setUniversidades] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [regionFilter, setRegionFilter] = useState('');
  const [estadoFilter, setEstadoFilter] = useState('');
  const [selectedUniversidad, setSelectedUniversidad] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const data = await getUniversidadesFromRTDB();
        setUniversidades(data);
        setFiltered(data);
      } catch (error) {
        console.error('Error loading universidades:', error);
        setFiltered([]);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  useEffect(() => {
    let result = universidades;

    if (id) {
      const uni = universidades.find(u => u.id === id);
      setSelectedUniversidad(uni || null);
    } else {
      setSelectedUniversidad(null);
    }

    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      result = result.filter(u =>
        u.nombre.toLowerCase().includes(q) ||
        u.siglas.toLowerCase().includes(q) ||
        u.estado.toLowerCase().includes(q) ||
        u.region.toLowerCase().includes(q)
      );
    }

    if (regionFilter) {
      result = result.filter(u => u.region === regionFilter);
    }

    if (estadoFilter) {
      result = result.filter(u => u.estado === estadoFilter);
    }

    setFiltered(result);
  }, [searchQuery, regionFilter, estadoFilter, universidades, id]);

  const regions = [...new Set(universidades.map(u => u.region).filter(Boolean))].sort();
  const estados = [...new Set(universidades.map(u => u.estado).filter(Boolean))].sort();

  const getConvocatoriaData = (siglas) => {
    return CONVOCATORIAS_POR_SIGLAS[siglas] || {
      convocatoria: 'Febrero-Marzo',
      registro: 'Febrero-Marzo',
      examen: 'Mayo-Junio',
      resultados: 'Junio',
      modalidad: 'Presencial / En Línea',
      notas: 'Consulta el portal oficial para fechas específicas de la convocatoria 2027.'
    };
  };

  if (selectedUniversidad) {
    const conv = getConvocatoriaData(selectedUniversidad.id);
    return (
      <div className="universidades-page">
        <div className="container">
          <button className="back-button" onClick={() => setSelectedUniversidad(null)}>
            <ChevronLeft size={18} />
            Volver al catálogo
          </button>

          <article className="universidad-detalle">
            <div className="detalle-header">
              <div className="detalle-badges">
                <span className="uni-badge">{selectedUniversidad.siglas}</span>
                <span className="uni-type">{selectedUniversidad.tipo}</span>
              </div>
              <h1>{selectedUniversidad.nombre}</h1>
              <div className="detalle-meta">
                <span><MapPin size={16} /> {selectedUniversidad.estado}{selectedUniversidad.region && ` · ${selectedUniversidad.region}`}</span>
                <span><GraduationCap size={16} /> {selectedUniversidad.total_carreras || selectedUniversidad.carreras?.length || 0} carreras</span>
              </div>
            </div>

            <div className="convocatoria-detalle">
              <h2>Convocatoria 2027</h2>
              <div className="convocatoria-grid">
                <div className="convocatoria-item">
                  <span className="convocatoria-label">Convocatoria</span>
                  <span className="convocatoria-value">{conv.convocatoria}</span>
                </div>
                <div className="convocatoria-item">
                  <span className="convocatoria-label">Registro en Línea</span>
                  <span className="convocatoria-value">{conv.registro}</span>
                </div>
                <div className="convocatoria-item">
                  <span className="convocatoria-label">Fecha de Examen</span>
                  <span className="convocatoria-value convocatoria-highlight">{conv.examen}</span>
                </div>
                <div className="convocatoria-item">
                  <span className="convocatoria-label">Resultados</span>
                  <span className="convocatoria-value">{conv.resultados}</span>
                </div>
                <div className="convocatoria-item">
                  <span className="convocatoria-label">Modalidad</span>
                  <span className="convocatoria-value">{conv.modalidad}</span>
                </div>
              </div>
              <p className="convocatoria-notas">{conv.notas}</p>
            </div>

            {selectedUniversidad.carreras && selectedUniversidad.carreras.length > 0 && (
              <div className="carreras-detalle">
                <h3>Carreras ({selectedUniversidad.carreras.length})</h3>
                <div className="carreras-grid">
                  {selectedUniversidad.carreras.slice(0, 30).map((carrera, idx) => (
                    <div key={idx} className="carrera-chip">
                      <BookOpen size={14} />
                      <span>{carrera.nombre}</span>
                    </div>
                  ))}
                </div>
                {selectedUniversidad.carreras.length > 30 && (
                  <p style={{ color: '#94a3b8', fontSize: '0.85rem', marginTop: '0.75rem' }}>
                    Mostrando 30 de {selectedUniversidad.carreras.length} carreras.
                  </p>
                )}
              </div>
            )}

            <div className="detalle-actions">
              {selectedUniversidad.enlaceOficial && (
                <a
                  href={selectedUniversidad.enlaceOficial}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-portal"
                >
                  <ExternalLink size={18} />
                  Portal Oficial
                </a>
              )}
              <Link to="/universidades-convocatorias" className="btn-secondary">
                <ChevronLeft size={18} />
                Volver al catálogo
              </Link>
            </div>
          </article>
        </div>
      </div>
    );
  }

  return (
    <div className="universidades-page">
      <div className="container">
        <div className="page-header">
          <button className="back-button" onClick={() => navigate('/')}>
            <ChevronLeft size={18} />
            Volver al inicio
          </button>
          <h1>Catálogo de Universidades y Convocatorias</h1>
          <p>
            {universidades.length} universidades registradas. Consulta fechas oficiales, requisitos y portales.
          </p>
        </div>

        <div className="filters-bar">
          <div className="search-box">
            <Search className="search-icon" size={18} />
            <input
              type="text"
              placeholder="Buscar universidad, siglas, estado..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <select value={regionFilter} onChange={(e) => setRegionFilter(e.target.value)} className="filter-select">
            <option value="">Todas las regiones</option>
            {regions.map(r => <option key={r} value={r}>{r}</option>)}
          </select>
          <select value={estadoFilter} onChange={(e) => setEstadoFilter(e.target.value)} className="filter-select">
            <option value="">Todos los estados</option>
            {estados.map(e => <option key={e} value={e}>{e}</option>)}
          </select>
        </div>

        {loading ? (
          <div className="loading-state">Cargando catálogo...</div>
        ) : (
          <>
            <div className="results-info">
              {filtered.length} universidades encontradas
            </div>
            <div className="universidades-list grid-view">
              {filtered.map((uni) => {
                const conv = getConvocatoriaData(uni.id);
                return (
                  <article key={uni.id} className="universidad-card" onClick={() => setSelectedUniversidad(uni)}>
                    <div className="card-header">
                      <span className="uni-badge">{uni.siglas}</span>
                      <span className="uni-type">{uni.tipo}</span>
                    </div>
                    <h3>{uni.nombre}</h3>
                    <div className="uni-meta">
                      <span><MapPin size={14} /> {uni.estado}</span>
                      <span><GraduationCap size={14} /> {uni.carreras?.length || 0} carreras</span>
                    </div>
                    <div className="conv-preview">
                      <div className="conv-item">
                        <Calendar size={14} />
                        <div>
                          <div className="conv-label">Convocatoria</div>
                          <div className="conv-value">{conv.convocatoria}</div>
                        </div>
                      </div>
                      <div className="conv-item">
                        <Calendar size={14} />
                        <div>
                          <div className="conv-label">Examen</div>
                          <div className="conv-value">{conv.examen}</div>
                        </div>
                      </div>
                    </div>
                    {uni.enlaceOficial && (
                      <a
                        href={uni.enlaceOficial}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="portal-link"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <ExternalLink size={14} />
                        Portal Oficial
                      </a>
                    )}
                  </article>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}